/* eslint-disable */
const hash = {
  "en-US": "f8fe3f7a",
  "de-DE": "d8b1fffd",
  "es-ES": "a2fa1467",
  "fr-FR": "5a77a976",
  "id-ID": "3ff7a1c2",
  "it-IT": "37c4f851",
  "jp-JP": "4cec794b",
  "ko-KO": "23b38472",
  "nl-NL": "48abb45f",
  "pl-PL": "2fe8647c",
  "pt-PT": "10a0d5db",
  "ru-RU": "225f270d",
  "sv-SE": "cfe8daa4",
  "tr-TR": "cb02d928",
  "vi-VN": "3cadcad1",
  "zh-CN": "42352db2",
  "zh-TW": "185afc57",
  "avatars": "086f70d2",
  "control": "448a0b66",
  "management": "281f4008",
  "custom-ai_companion": "39e4a6b8",
  "plan-details": "21322ee4",
  "gov-EN": "84245fc8",
  "en-GB": "f1ba9162"
}
export default hash
